<template>
  <div class="content">
    <div class="filter">
      <input
        type="radio"
        v-model="selectedCategory"
        value="all"
        name="all"
        id="all"
      />
      <label for="all">A leggazdagabb magyarok</label>
      <input
        type="radio"
        v-model="selectedCategory"
        value="Kat1"
        name="Kat1"
        id="Kat1"
      />
      <label for="Kat1">Üzletelt Mészárossal</label>
    </div>

    <div class="persons">
      <div
        v-for="person in filteredPeople"
        v-bind:key="person.name"
        :class="'item '+person.image"
      >
        <div class="inner">
          <div
            class="pname"
            v-if="person.name"
          >{{ person.name }}</div>
          <div
            class="pid"
            v-if="person.position"
          >{{person.position}}</div>
          <div
            class="vagyon"
            v-if="person.vagyon"
          >
            {{person.vagyon}} milliárd Ft
            <!--<div :class="'tooltip '+person.status">
              <div
                class="tiptext"
                v-if="person.status === 'up'"
              >
                <div class="arrow"></div>
                Vagyona nőtt az előző évhez képest
              </div>
              <div
                class="tiptext"
                v-if="person.status === 'down'"
              >
                <div class="arrow"></div>
                Vagyona csökkent az előző évhez képest
              </div>
              <div
                class="tiptext"
                v-if="person.status === 'plus'"
              >
                <div class="arrow"></div>
                Új!
              </div>
              <div
                class="tiptext"
                v-if="person.status === 'minus'"
              >
                <div class="arrow"></div>
                Vagyona nem változott az előző évhez képest
              </div>
              <div
                class="tiptext"
                v-if="person.status === 'star'"
              >
                <div class="arrow"></div>
                Vagyona csúcsugró az előző évhez képest
              </div>
            </div>-->
          </div>
          <div
            class="about"
            v-if="selectedCategory === 'all'"
          >{{person.text}}</div>
          <div
            class="about"
            v-if="selectedCategory === 'Kat1'"
          >{{person.kat1text}}</div>
          <a
            href="http://bit.ly/2UZ5r3N"
            title="Mercedes Benz - Előzze meg a jövőt."
            target="_blank"
            v-if="person.banner"
          ><img
              src="../assets/img/banner/Mercedes-banner-s-1.jpg"
              alt="Mercedes Benz - Előzze meg a jövőt."
            ></a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'ContentComponent',
  data() {
    return {
      people: [
        {
          category: 'Kat1',
          banner: true,
          image: 'banner',
        },
        {
          position: '1.',
          name: 'Mészáros Lőrinc',
          category: '',
          vagyon: '381,3',
          status: '',
          text: 'Megelőzte Csányit, dollármilliárdos lett. A tőzsdén ment hatalmasat, a turizmusban, energetikában is nagybefektető lett.',
          image: 'person1',
        },
        {
          position: '2.',
          name: 'Csányi Sándor',
          category: 'Kat1',
          vagyon: '317,2',
          status: '',
          text: 'Cégei jól mentek, nem lehet oka panaszra - helyzete egyetlen év alatt mégis sokat változott.',
          kat1text: 'Eladta neki a Geosolt biomasszacéget, az OTP csoport vásárolt részvényeket Mészáros tőzsdei érdekeltségeiből.',
          image: 'person2',
        },
        {
          position: '3.',
          name: 'Gattyán György',
          category: '',
          vagyon: '244,7',
          status: '',
          text: 'Online hotelszoba-foglaló oldala jól ment, és számos ígéretes céget felvásárolt a Gattyán Group.',
          image: 'person3',
        },
        {
          position: '4.',
          name: 'Demján örökösök',
          category: 'Kat1',
          vagyon: '186',
          status: '',
          text: '2020-ban letehetik az új városrész, a Central Park alapkövét a Nyugati mögött. Demján szellemiségét viszi tovább csapata.',
          kat1text: 'Mészáros értékes borászatokat vett Demjántól három éve.',
          image: 'person4 fantomd',
        },
        {
          position: '5.',
          name: 'Veres Tibor',
          category: 'Kat1',
          vagyon: '160,6',
          status: '',
          text: 'A Wallis autós cégeit tőzsdére viszi, a Wing felépítette a Magyar Telekom székházát a Fradi stadionja mellett.',
          kat1text: 'Korábban Veresnek is volt részvénycsomagja az Appeninn Holdingban, ahova Mészáros beszállt. ',
          image: 'person5',
        },
        {
          position: '6.',
          name: 'Felcsuti',
          category: '',
          vagyon: '151,5',
          status: '',
          text: 'Az MPF Holding a régió egyik legnagyobb ipari befektetője, a 70-es évek szövetkezeti világából indultak. A teljes sztori a januári Forbesban!',
          image: 'person6',
        },
        {
          position: '7.',
          name: 'Széles Gábor',
          category: 'Kat1',
          vagyon: '151,2',
          status: '',
          text: 'Zalacsányban tovább épül a magyar Toscana.',
          kat1text: 'Az Echo TV-t eladta Mészárosnak.',
          image: 'person7',
        },
        {
          position: '8.',
          name: 'Bige László',
          category: '',
          vagyon: '110',
          status: '',
          text: 'Nehéz helyzetbe került, a Nitrogénművek sok adósságot nyög, a műtrágya ára esett. Év végén több száz rendőr vonult ki szolnoki gyárához.',
          image: 'person8',
        },
        {
          position: '9.',
          name: 'Szíjj László',
          category: 'Kat1',
          vagyon: '106,2',
          status: '',
          text: 'Lenyelte a Közgépet az állami közbeszerzések újdonsült egyeduralkodója. Mészáros Lőrinc közeli üzlettársa.',
          kat1text: 'Több közös érdekeltségük is van.',
          image: 'person9',
        },
        {
          position: '10.',
          name: 'Kasza Lajos',
          category: '',
          vagyon: '94,4',
          status: '',
          text: 'Az autóipar felfutásával jól járt, az akkumulátorgyártó és fröccsöntő Jász-Plasztiknak soha nem ment ilyen jól.',
          image: 'person10',
        },
        {
          position: '11.',
          name: 'Lakatos Péter',
          category: '',
          vagyon: '84',
          status: '',
          text: 'A Videoton Holding brutális adatokat produkál évről évre, Európa öt legnagyobb szerződéses gyártója között vannak.',
          image: 'person11',
        },
        {
          position: '12.',
          name: 'Rákosi Tamás',
          category: 'Kat1',
          vagyon: '83,5',
          status: '',
          text: 'A médiamogul, az egykori RTL Klub-tulajdonos beszállít a TV2-nek, része van az Atmediában is.',
          kat1text: 'Az Atmediában együtt tulajdonosok.',
          image: 'person12',
        },
        {
          position: '13.',
          name: 'Wáberer György',
          category: '',
          vagyon: '83,3',
          status: '',
          text: 'Ingatlanban utazik a kamionkirály: zajlik a budai SZOT-üdülő átépítése és elkészült új irodaháza az Alkotás úton.',
          image: 'person13',
        },
        {
          position: '14.',
          name: 'Leisztinger Tamás',
          category: 'Kat1',
          vagyon: '82,4',
          status: '',
          text: 'Újra nekiveselkedhet a Köki Terminál bevásárlókomplexumnak. Szállodáit Mészáros vette meg.',
          kat1text: 'Szállodáit Mészárosnak adta el.',
          image: 'person14',
        },
        {
          position: '15.',
          name: 'Sinkó Ottó',
          category: '',
          vagyon: '80',
          status: '',
          text: 'A Videoton társügyvezetője és tulajdonosa társaival felépítette az ország legértékesebb teljesen magyar kézben lévő vállalatát.',
          image: 'person15',
        },
        {
          position: '16.',
          name: 'Futó Gábor és Dr Futó Péter',
          category: '',
          vagyon: '71',
          status: '',
          text: 'A Cordia és a Futureal megállíthattlanul fejleszt: Kelenföldön gigaplázát és irodaházakat, például.',
          image: 'person16',
        },
        {
          position: '17.',
          name: 'Bárány László',
          category: '',
          vagyon: '69,3',
          status: '',
          text: 'A kisvárdai Master Good a baromfipiac vezetője idehaza, kisvárdai vágóhídjukat most bővítették tovább.',
          image: 'person17',
        },
        {
          position: '18.',
          name: 'Vajna András György',
          category: 'Kat1',
          vagyon: '67,3',
          status: '',
          text: 'A kaszinókirály Mészárosnak adta értékes lapjait (Bors, Kisalföld, Délmagyarország), de továbbra is erős ember a magyar médiában, övé a TV2 és része van az Atmediában is.',
          kat1text: 'Az Atmediában együtt tulajdonosok.',
          image: 'person18',
        },
        {
          position: '19.',
          name: 'Kertész Attila és Viktor',
          category: '',
          vagyon: '64,9',
          status: '',
          text: 'Több mint 20 éve foglalkoznak rendszámfeismerő rendszerekkel, ma már széles termékportfólióval, világ szinten.',
          image: 'person19 fantomd',
        },
        {
          position: '20.',
          name: 'Szabó Miklós',
          category: '',
          vagyon: '64,8',
          status: '',
          text: 'Víziszárnyas-feldolgozásban Európa legnagyobbja, a családi cég 70%-át eladta a francia LDC csoportnak, vegyesvállalatot hoztak létre.',
          image: 'person20',
        },
        {
          position: '21.',
          name: 'Nagy Elek',
          category: '',
          vagyon: '58,9',
          status: '',
          text: 'A BÁV többségi tulajdonosa az egykori Vegyépszer-vezér, de van taxitársasága is.',
          image: 'person21',
        },
        {
          position: '22.',
          name: 'Garancsi István',
          category: '',
          vagyon: '57,3',
          status: '',
          text: 'Megvette a GS4 pénzszállító céget és eladta a MET energetikai holdingban jegyzett kisebbségi részét.',
          image: 'person22',
        },
        {
          position: '23.',
          name: 'Bolgár György',
          category: '',
          vagyon: '50,4',
          status: '',
          text: 'A Bolgár család tulajdonában lévő Kerox Kft. a világ egyik legnagyobb ipari kerámiagyártó cége, 30 éve vannak a piacon.',
          image: 'person23 fantom',
        },
        {
          position: '24.',
          name: 'Varga Zoltán',
          category: '',
          vagyon: '44,9',
          status: '',
          text: 'Beszállt egy repülőautót fejlesztő szlovák startupba, egy argentin fapados légitársaságba, rendületlenül terjeszkedik Lengyelországban.',
          image: 'person24',
        },
        {
          position: '25.',
          name: 'Zettwitz Sándor',
          category: '',
          vagyon: '44,5',
          status: '',
          text: 'Vércukormérőjük a világon a legpontosabb, de a cég növekedését saját fejlesztésű vizeletvizsgáló készülékük térnyerése hajtja.',
          image: 'person25',
        },
        {
          category: 'Kat1',
          banner: true,
          image: 'banner',
        },
        {
          position: '26.',
          name: 'Varga Károly',
          category: 'Kat1',
          vagyon: '43,7',
          status: '',
          text: 'A főleg mélyépítésben utazó Magyar Vakond konszolidált árbevétele meghaladta az 52 milliárd forintot.',
          kat1text: 'Kiszállt a Duna Aszfaltból, de Szíjjel együtt Mészáros köréhez sorolják.',
          image: 'person26 fantom',
        },
        {
          position: '27.',
          name: 'Szemerey Tamás',
          category: 'Kat1',
          vagyon: '41,7',
          status: '',
          text: 'Élete üzlete lehet, hogy beszállt az MKB-ba. Megvette a Pécsi Sörfőzdét is, a cég már profitot is termelt.',
          kat1text: 'Az MKB másik nagy tulajdonosa, Mészárosé a bank 49 százaléka. ',
          image: 'person27',
        },
        {
          position: '28.',
          name: 'Simicska Lajos',
          category: 'Kat1',
          vagyon: '40,7',
          status: '',
          text: 'Az exodus éve: eladott mindent és levonult az egykor nagyhatalmú oligarcha.',
          kat1text: 'Nyerges Zsolt érintésével tőle vette meg a Mezort agrárbitodalmat. ',
          image: 'person28',
        },
        {
          position: '29.',
          name: 'Emőri Gábor',
          category: 'Kat1',
          vagyon: '40,1',
          status: '',
          text: 'Annak idején volt Farkas Bertalan sofőrje is, IT-cégeinek köszönhetően lett milliárdos.',
          kat1text: 'Mészáros beszállt az Appeninn Holdingba, ahol korábban Emőrinek is nagyobb részesedése volt.',
          image: 'person29',
        },
        {
          position: '30.',
          name: 'Zombori Antal',
          category: '',
          vagyon: '39',
          status: '',
          text: 'Az ország legnagyobb autóalkatrész-kereskedelmének egyszemélyes tulajdonosa 1990 óta.',
          image: 'person30',
        },
        {
          position: '31.',
          name: 'Nyúl Sándor',
          category: '',
          vagyon: '38',
          status: '',
          text: 'Eladta részét a Gránit Banknból, befektetett egy szlovák energetikai cégbe.',
          image: 'person31',
        },
        {
          position: '32.',
          name: 'Szatmári Zoltán',
          category: '',
          vagyon: '37,4',
          status: '',
          text: 'Bolthálózatuk országos, ha kell valami a fürdőszobába, náluk ott van - de van malmuk is, agrárcégeik is jól mennek.',
          image: 'person32',
        },
        {
          position: '33.',
          name: 'Sándor József',
          category: '',
          vagyon: '36,6',
          status: '',
          text: 'Az ország legnagyobb öntödéje az övé, stabil autóipari beszállító.',
          image: 'person33',
        },
        {
          position: '33.',
          name: 'Dunai György',
          category: 'Kat1',
          vagyon: '36,6',
          status: '',
          text: 'Építőipari vállalatcsoportja túl van a zenitjén, de Mészárossal együtt több nagy értékű közbeszerzést is elnyert.',
          kat1text: 'Mészárossal együtt konzorciumban nyert közbeszerzéseket.',
          image: 'person34 fantom',
        },
        {
          position: '35.',
          name: 'Krankovics István',
          category: '',
          vagyon: '33,4',
          status: '',
          text: 'A legsikeresebb hazai buszgyártó, és a legendás Kühne mezőgépgyár tulajdonosa.',
          image: 'person35',
        },
        {
          position: '36.',
          name: 'Harsányi Zsolt',
          category: '',
          vagyon: '31,4',
          status: '',
          text: 'Az Axiál az ország legnagyobb mezőgép-kereskedője, szervízhálózatuk is lefedi az országot.',
          image: 'person36',
        },
        {
          position: '37.',
          name: 'Laczay Péter',
          category: '',
          vagyon: '29,1',
          status: '',
          text: 'Kistarcsán állatgyógyszereket fejlesztő és gyártó Lavet nagyot lépett előre egy év alatt, pörög az export.',
          image: 'person37',
        },
        {
          position: '38.',
          name: 'Lévai család',
          category: '',
          vagyon: '28,6',
          status: '',
          text: 'Masszív terjeszkedésben a Biotech USA táplálékkiegészítő gyártója.',
          image: 'person38',
        },
        {
          position: '39.',
          name: 'Nyerges Zsolt',
          category: 'Kat1',
          vagyon: '27,5',
          status: '',
          text: 'Jó üzletet kötött a Közgégben és a Mezortban meglévő kisebbségi részének eladásával.',
          kat1text: 'Végül ő adta el a Mezortot Mészárosnak, a Duna Aszgaltot pedig Szíjj Lászlónak.',
          image: 'person39',
        },
        {
          position: '40.',
          name: 'Kenyeres fivérek',
          category: '',
          vagyon: '25,9',
          status: '',
          text: 'A Kenyeres testvérek teljes vagyonát a Mogyi Kft. és hat külföldi leányvállalata adja. 27 országban vannak jelen, Ázsiában terjeszkednek.',
          image: 'person40 fantom',
        },
        {
          position: '41.',
          name: 'Majoros Béla',
          category: '',
          vagyon: '25,7',
          status: '',
          text: 'A járműipar számára alumínium alkatrészeket gyártó Csaba Metál a családi vagyon több mint nyolcvan százalékát teszi ki, a Audi, a BMW és a Mercedes stabil beszállítója.',
          image: 'person41',
        },
        {
          position: '42.',
          name: 'Hernádi Zsolt',
          category: '',
          vagyon: '25,6',
          status: '',
          text: '18 éve vezeti a Molt, de egyre több befektetést eszközöl alapjain keresztül, melyekkel EU-s pénzeket is elnyert.',
          image: 'person42',
        }, {
          position: '43.',
          name: 'Paár Attila',
          category: '',
          vagyon: '25,5',
          status: '',
          text: 'A lista legfiatalabb tagja, a WHB építőipari cégcsoport tulajdonosa, közeli üzlettársa Tiborcz Istvánnak.',
          image: 'person43 fantom',
        }, {
          position: '44.',
          name: 'Bojár Gábor',
          category: '',
          vagyon: '24,4',
          status: '',
          text: 'A Graphisoft alapítója, ingatlanos cége szépen terjeszkedik az észak-pesti Duna parton.',
          image: 'person44',
        }, {
          position: '45.',
          name: 'Váradi József',
          category: '',
          vagyon: '24,2',
          status: '',
          text: 'A WizzAir alapító újabban Mádon borászkodik.',
          image: 'person45',
        }, {
          position: '46.',
          name: 'Nagy György',
          category: 'Kat1',
          vagyon: '22,9',
          status: '',
          text: 'Csányi Sándor közeli üzlettársa, a MET energetikai holding legnagyobb magánszemély tulajdnosa volt, de tavaly kiszállt.',
          kat1text: 'A mátrai Geosolban neki is volt része, Csányival együtt eladta Mészárosnak.',
          image: 'person46',
        }, {
          position: '46.',
          name: 'Balogh Levente',
          category: '',
          vagyon: '22,9',
          status: '',
          text: 'A Szentkirályi alapítója olasz üzlettársaival egyre erősebb régiós bástyát épít ki, átvették a PepsiCo-t is.',
          image: 'person47',
        }, {
          position: '48.',
          name: 'Scheer Sándor',
          category: '',
          vagyon: '21,8',
          status: '',
          text: 'A Market alapító-kisebbségi tulajdonosának is jól megy, megrendelés van bőven.',
          image: 'person48',
        }, {
          position: '49.',
          name: 'Schmidt Mária',
          category: 'Kat1',
          vagyon: '21,2',
          status: '',
          text: 'Tovább növelte befolyását az értékes tőzsdei ingatlanos cégben, a BIF-ben.',
          kat1text: 'A Mészároshoz köthető Takarékbank bevásárolta magát a BIF Nyrt-be.',
          image: 'person49',
        }, {
          position: '50.',
          name: 'Tarr család',
          category: '',
          vagyon: '19,7',
          status: '',
          text: 'A szekszárdi vállalkozás jól tartja magát a multik ellen a távközlési piacon, több mint 300 településen van jelen internet-, kábeltévé-, mobil- és vezetékestelefon-szolgáltatással.',
          image: 'person50',
        },
        {
          category: 'Kat1',
          banner: true,
          image: 'banner',
        },
      ],
      selectedCategory: 'all',
    };
  },
  computed: {
    filteredPeople() {
      const category = this.selectedCategory;
      if (category === 'all') {
        return this.people;
      }
      return this.people.filter(person => person.category === category);
    },
  },
};
</script>

<style scoped lang="css">
.content {
  background-color: #fff;
}
.filter {
  text-transform: uppercase;
  display: flex;
  padding: 20px 30px;
  justify-content: center;
}
label {
  margin: 0 20px;
  cursor: pointer;
  height: 27px;
  display: inline-block;
  font-weight: 700;
  font-size: 12px;
}
input[type="radio"] {
  display: none;
}
input[type="radio"]:checked + label {
  background-image: linear-gradient(
    to bottom,
    #404040,
    #404040 7%,
    #404040 7%,
    #404040
  );
  background-position: 0 23px;
  background-size: 4px 4px;
  background-repeat: repeat-x;
}
.persons {
  display: flex;
  flex-wrap: wrap;
}
.inner {
  padding: 20px;
  display: grid;
  grid-template-columns: auto 70px;
  grid-template-rows: auto auto auto;
}
.item {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: right bottom;
  flex-basis: calc(100% / 3);
  line-height: 1.3;
}
.item.fantomd {
  background-image: url("../assets/img/person/fantom-d.png");
}
.item.fantom {
  background-image: url("../assets/img/person/fantom.png");
}
.item.person1 {
  background-image: url("../assets/img/person/meszaros-lorinc-min.png");
}
.item.person2 {
  background-image: url("../assets/img/person/csanyi-sandor-min.png");
}
.item.person3 {
  background-image: url("../assets/img/person/gattyan-gyorgy-min.png");
}
.item.person5 {
  background-image: url("../assets/img/person/veres-tibor-min.png");
}
.item.person6 {
  background-image: url("../assets/img/person/felcsuti-zsolt-min.png");
}
.item.person7 {
  background-image: url("../assets/img/person/szeles-gabor-min.png");
}
.item.person8 {
  background-image: url("../assets/img/person/bige-laszlo-min.png");
}
.item.person9 {
  background-image: url("../assets/img/person/Szijj-Laszlo.png");
}
.item.person10 {
  background-image: url("../assets/img/person/kasza-lajos-min.png");
}
.item.person11 {
  background-image: url("../assets/img/person/lakatos-peter-min.png");
}
.item.person12 {
  background-image: url("../assets/img/person/rakosi-tamas-min.png");
}
.item.person13 {
  background-image: url("../assets/img/person/waberer-gyorgy-min.png");
}
.item.person14 {
  background-image: url("../assets/img/person/leisztinger-tamas-min.png");
}
.item.person15 {
  background-image: url("../assets/img/person/sinko-otto-min.png");
}
.item.person16 {
  background-image: url("../assets/img/person/Futoek.png");
}
.item.person17 {
  background-image: url("../assets/img/person/barany-laszlo-min.png");
}
.item.person18 {
  background-image: url("../assets/img/person/vajna-andras-min.png");
}
.item.person20 {
  background-image: url("../assets/img/person/szabo-miklos-min.png");
}
.item.person21 {
  background-image: url("../assets/img/person/nagy-elek.png");

}
.item.person22 {
  background-image: url("../assets/img/person/garancsi-istvan-min.png");
}
.item.person24 {
  background-image: url("../assets/img/person/varga-zoltan-min.png");
}
.item.person25 {
  background-image: url("../assets/img/person/zettwitz-sandor-min.png");
}
.item.person27 {
  background-image: url("../assets/img/person/Szemerey-Tamas.png");
}
.item.person28 {
  background-image: url("../assets/img/person/simicska-lajos-min.png");
}
.item.person29 {
  background-image: url("../assets/img/person/emori-gabor-min.png");
}
.item.person30 {
  background-image: url("../assets/img/person/zombori-antal-min.png");
}
.item.person31 {
  background-image: url("../assets/img/person/nyul-sandor-min.png");
}
.item.person32 {
  background-image: url("../assets/img/person/szatmari-zoltan-min.png");
}
.item.person33 {
  background-image: url("../assets/img/person/sandor-jozsef-min.png");
}
.item.person35 {
  background-image: url("../assets/img/person/Krankovics-Istvan.png");
}
.item.person36 {
  background-image: url("../assets/img/person/harsanyi-zsolt-min.png");
}
.item.person37 {
  background-image: url("../assets/img/person/Laczay-Peter.png");
}
.item.person38 {
  background-image: url("../assets/img/person/Levayek.png");
}
.item.person39 {
  background-image: url("../assets/img/person/Nyerges-Zsolt.png");
}
.item.person41 {
  background-image: url("../assets/img/person/Majoros-Csanad.png");
}
.item.person42 {
  background-image: url("../assets/img/person/Hernadi-Zsolt-Tamas.png");
}
.item.person44 {
  background-image: url("../assets/img/person/Bojar-Gabor-Zoltan.png");
}
.item.person45 {
  background-image: url("../assets/img/person/Varadi-Jozsef.png");
}
.item.person46 {
  background-image: url("../assets/img/person/Nagy-Gyorgy.png");
}
.item.person47 {
  background-image: url("../assets/img/person/Balogh-Levente.png");
}
.item.person48 {
  background-image: url("../assets/img/person/Scheer-Sandor.png");
}
.item.person49 {
  background-image: url("../assets/img/person/Schmidt-Maria.png");
}
.item.person50 {
  background-image: url("../assets/img/person/Tarr-Csanad.png");
}
.item:nth-child(1n) {
  background-color: #151515;
}
.item:nth-child(2n) {
  background-color: #464646;
}
.item:nth-child(3n) {
  background-color: #2a2a2a;
}
.pname {
  font-size: 25px;
  font-weight: 700;
  color: #fff;
  font-family: "Yeseva One", cursive;
  grid-column: 1/2;
  grid-row: 1/2;
  letter-spacing: 1px;
}
.pid {
  font-size: 35px;
  background-color: #fff;
  width: 55px;
  height: 55px;
  border-radius: 50%;
  display: grid;
  justify-content: center;
  align-content: center;
  font-family: "Yeseva One", cursive;
  grid-column: 2/3;
  grid-row: 1/3;
}
.vagyon {
  font-style: italic;
  font-size: 20px;
  color: #fff;
  grid-column: 1/2;
  grid-row: 2/3;
}
.about {
  color: #fff;
  font-size: 14px;
  font-style: italic;
  grid-column: 1/3;
  grid-row: 3/4;
  margin: 15px 0 70px 0;
  padding-right: calc(50% - 45px);
}
.tooltip {
  display: inline-block;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  position: relative;
}
.up {
  background-color: red;
}
.down {
  background-color: blue;
}
.plus {
  background-color: yellow;
}
.minus {
  background-color: black;
}
.star {
  background-color: green;
}
.tiptext {
  display: none;
  bottom: -55px;
  left: -71px;
  width: 150px;
  padding: 5px 3px;
  border-radius: 3px;
  font-style: normal;
  position: absolute;
  background-color: black;
  color: #fff;
  text-align: center;
}
.tooltip:hover .tiptext {
  display: block;
}
.tiptext .arrow {
  left: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-color: rgba(136, 183, 213, 0);
  border-bottom-color: #000000;
  border-width: 5px;
  margin-left: -5px;
  top: -10px;
}
.item.banner {
  display: none;
  background-color: #b2b3b5;
}
.item.banner .inner {
  padding: 0px;
}
.item.banner .about {
  display: none;
}
.item.banner .inner a {
  grid-column: 1/3;
  grid-row: 1/4;
  display: grid;
}
.item.banner img {
  width: 100%;
}
@media screen and (max-width: 1189px) {
  .item.banner {
    display: block;
  }
}
@media screen and (max-width: 1024px) {
  .about {
    padding-right: calc(50% - 20px);
  }
}
@media screen and (max-width: 767px) {
  .item {
    flex-basis: calc(100% / 2);
  }
  .pid {
    font-size: 32px;
  }
}
@media screen and (max-width: 540px) {
  .item {
    flex-basis: 100%;
    background-size: 200px;
  }
  .filter {
    flex-wrap: wrap;
  }
  input[type="radio"]:checked + label {
    background-position: 0px 16px;
  }
  .about {
    padding-right: calc(35% - 20px);
  }
}
</style>
